// extracted by mini-css-extract-plugin
export var markdown = "Markdown-module--markdown--pVzCO";
export var readMore = "Markdown-module--readMore--gSz9u";
export var readMoreButton = "Markdown-module--readMoreButton--gZi4o";
export var themeLight = "Markdown-module--themeLight--RoAQO";